module.exports = __webpack_public_path__ + "img/ev-charging-building.fb547df2.png";